export interface TSwipePoint {
  time: number;
  x: number;
  y: number;
}

/** Below this the gesture is a tap, or the slack in one. */
const MIN_DISTANCE = 60;

/**
 * How much longer the leg along the axis has to be than the one across it. A
 * gesture that wanders must not count as the wrong one.
 */
const MIN_RATIO = 1.5;

/** Past this it reads as a drag, or a scroll that happened to end sideways. */
const MAX_DURATION = 800;

type TAxis = "x" | "y";

/** `sign` is the direction along the axis: -1 for left or up, 1 for down. */
function isSwipe(
  from: TSwipePoint,
  to: TSwipePoint,
  axis: TAxis,
  sign: -1 | 1
): boolean {
  if (to.time - from.time > MAX_DURATION) {
    return false;
  }

  const distanceX = to.x - from.x;
  const distanceY = to.y - from.y;
  const along = axis === "x" ? distanceX : distanceY;
  const across = axis === "x" ? distanceY : distanceX;

  if (sign * along < MIN_DISTANCE) {
    return false;
  }

  return Math.abs(along) >= Math.abs(across) * MIN_RATIO;
}

/** Towards the left edge — the direction the drawer slides out to. */
export function isSwipeLeft(from: TSwipePoint, to: TSwipePoint): boolean {
  return isSwipe(from, to, "x", -1);
}

/** Downwards, which pushes the city sheet back into the footer it came from. */
export function isSwipeDown(from: TSwipePoint, to: TSwipePoint): boolean {
  return isSwipe(from, to, "y", 1);
}
